import MenuCartBarV2 from './MenuCartBarV2';

export default MenuCartBarV2;
